// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"bc701460","432":"bdb96094","449":"f5a2daa8","745":"bc701460","973":"bc701460"}[chunkId] + ".chunk.css";
};